module.exports = __webpack_public_path__ + "static/iosBannerTyresFebruary-495075221357c7449033af25c7725f0d.jpg";